import { render, staticRenderFns } from "./ServiceSelector.vue?vue&type=template&id=90f9220c&"
import script from "./ServiceSelector.vue?vue&type=script&lang=js&"
export * from "./ServiceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports